import { useSelector } from 'react-redux';
import Lockets from '../home/custom/Lockets';
import ClassicHome from './ClassicHome';
import Wallets from './custom/Wallets';

const Home = () => {
  const lab = useSelector((s) => s.lab);
  if (lab.lab_id === 'lockets') {
    return <Lockets />;
  } else if (lab.lab_id === 'wallets') {
    return <Wallets />;
  } else {
    return <ClassicHome />;
  }
};
export default Home;
